// @TODO: remove ignore when using final service
/* eslint-disable camelcase */
import { components } from './address.schema'

export enum AddressType {
  BILLING = 'BILLING',
  INSTALLATION = 'INSTALLATION',
  SIM = 'SIM',
  TERMINAL = 'TERMINAL',
  SERVICE = 'SERVICE',
}

export enum AddressesOptions {
  SAME = 'SAME_ADDRESS',
  OTHER = 'OTHER_ADDRESS',
}
export interface ErrorInterface {
  errorMessage?: string
  errorCode?: string
}

export interface SetAddressPayload {
  id: string
  addressType: AddressType
  address: Address
}

interface HorizontalAddress {
  gescal?: string
  streetType?: string // @TODO Find out all possible types and make an enum
  streetName?: string
  number?: string
  postalCode?: string
  town?: string
  province?: string
  provinceId: string
  summary?: string
  description?: string
  otherInfo?: string
  addressOwner?: AddressesOptions
  addressInput?: string
}

export interface VerticalAddress {
  gescal?: string
  floor?: string
  letter?: string // @TODO [Back] Mapear aqui "letter" y "door"
  otherInfo?: string // @TODO [Back] Mapear aqui: stair, hand1, y hand2
}

export type Address = HorizontalAddress & Partial<VerticalAddress>

export type AddressApiResponse = components['schemas']['horizontalAddressesResponse']

export interface StreetsApiResponse {
  id: string
  address: AddressApiResponse
}

export type AddressDataState = ErrorInterface & {
  loading: boolean
  data: Address
  addressOwner?: AddressesOptions
}

type AddressesTypesState = {
  [key: string]: AddressDataState
}

export type AddressState = {
  [key: string]: AddressesTypesState
}

export interface CoverageApiSpeedsResponse {
  estimated: string
  profile: string
}

export interface CoverageApiResponse {
  technology: string
  territory_owner: string
  pai_local: string
  terminal_exchange: string
  pai: string
  availability: boolean
  priority?: string
  speeds: CoverageApiSpeedsResponse
}

// @TODO: remove api interfaces in favor of openAPI
export interface AddressDescriptionApiResponse {
  bis_duplicate: string
  block: string
  door: string
  letter: string
  stair: string
  floor: string
  hand1: string
  hand2: string
  summary: string
}

export interface UnitApiResponse {
  id: string
  technical_id: string
  address_description: AddressDescriptionApiResponse
}

export interface BuildingApiResponse extends StreetsApiResponse {
  coverage: CoverageApiResponse[]
  units: UnitApiResponse[]
}

export type clientSearchResponseAddressInfo = {
  streetName?: string | undefined
  province?: string | undefined
  provinceId: number
  postalCode?: number | undefined
  town?: string | undefined
  summary?: string | undefined
}

export type clientSearchResponseAddressStore = {
  streetName?: string
  province?: string
  provinceId: string
  postalCode?: string
  town?: string
  summary?: string
}
